
import ClientSelection from "../components/ClientSelection.jsx";
import { Box} from "@mui/material";
import { useRoleLayout } from "../hooks/useRoleLayout";

const ClientSelectionPage = () => {
  const {  Layout } = useRoleLayout();
  
  return (
    <Layout>
      <Box
        sx={{
          p: 3,
          display: "flex",
          flexDirection: "column",
          gap: 2
        }}
      >
        
        <ClientSelection />
      </Box>
    </Layout>
  );
};

export default ClientSelectionPage;
